// Function to handle click event and save attribute value and page URL in localStorage
$(document).on('click', 'ul#product-grid li.grid__item', function () {
    // Get the value of the 'name' attribute
    var nameValue = $(this).attr('name');
    // Get the current page URL
    var pageUrl = window.location.href;
    
    if (nameValue) {
        // Save the attribute value and the page URL in localStorage
        localStorage.setItem('lastClickedItemName', JSON.stringify({
            name: nameValue,
            url: pageUrl
        }));
    }
});

// Function to scroll to the saved 'li' element
function scrollToSavedItem() {
    // Get the saved data from localStorage
    var savedData = localStorage.getItem('lastClickedItemName');
    if (savedData) {
        var parsedData = JSON.parse(savedData);
        var savedNameValue = parsedData.name;
        var savedPageUrl = parsedData.url;

        // Check if the saved URL matches the current page URL
        if (savedPageUrl === window.location.href) {
            // Find the 'li' element with the saved 'name' attribute value
            var targetLi = $('ul#product-grid li.grid__item[name="' + savedNameValue + '"]');
            if (targetLi.length) {
                // Scroll to the target 'li' element, offset by 150px
                $('html, body').animate({
                    scrollTop: targetLi.offset().top - 150
                }, 500); // Adjust the speed of scrolling (500ms) as needed
                
                // Optional: Remove the item from localStorage after scrolling to it
                localStorage.removeItem('lastClickedItemName');
            }
        }
    }
}

// Run the scroll function when the page is first loaded
window.addEventListener('load', function () {
    scrollToSavedItem();
});

// Run the scroll function when the browser history changes (e.g., navigating back)
$(window).on('popstate', function () {
    scrollToSavedItem();
});

// Handle the page show event (e.g., when navigating back to the page from the browser cache)
(function () {
    window.onpageshow = function (event) {
        if (event.persisted) {
            scrollToSavedItem();
        }
    };
})();

///////////////////////////////////////////////////////////
     // Click event for Recently Viewed tab
  $(".both-tab-headings h2.recently_viewed").click(function() {
    console.log("recently_viewed");
    $("product-recommendations.releted_items").hide(); // Hide related items
    $("product-recommendations.recently_viewed").show(); // Show recently viewed items
  });

  // Click event for Related Items tab
  $(".both-tab-headings h2.releted_items").click(function() {
    console.log("releted_items");
    $("product-recommendations.recently_viewed").hide(); // Hide recently viewed items
    $("product-recommendations.releted_items").show(); // Show related items
  });

///////////////////////////////////////////////////////////


